export const selectToast = (state) => state.notification.currentToast;
